import React, { type ReactNode } from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";

export enum SPIN_STATUS {
  /** 数据加载成功 正常渲染 */
  SUCCESS = "success",
  /** 数据加载中 遮盖内容 显示 loading */
  LOADING = "loading",
  /** 问题思考中 遮盖内容 显示 thinking */
  THINKING = "thinking",
  /** 数据加载失败 遮盖内容 渲染错误状态 */
  ERROR = "error",
  /** 没有数据 */
  EMPTY = "empty",
}

export type SpinPropsTypes = {
  loadingClassName?: string;
  status: SPIN_STATUS;
  reload: () => void;
  renderLoading?: ReactNode;
  renderError?: ReactNode;
  renderEmpty?: ReactNode;
  className?: string | undefined;
  children?: ReactNode;
};

const DefaultErrorContent = (props: { reload: () => void }) => {
  const { reload } = props;
  return (
    <div>
      <div className="flex items-center gap-2 bg-content_accent2_primary/10 w-[621px] rounded-2xl p-4 mt-4">
        <div className="flex items-center justify-center rounded-full border-content_accent2_primary border-2">
          <Icon name="error-ic" className="text-content_accent2_primary" />
        </div>
        <div className="body_m text-content_accent2_primary">
          {`Oops! Looks like something went wrong. Search again! If this issue keeps happening, hit us up on Discord and we'll get it fixed ASAP! 🩵`}
        </div>
      </div>
      <Icon
        data-openreplay-label="revision"
        onClick={reload}
        name="revision"
        className="text-content_primary/60 mt-[36px]"
        size={20}
      />
    </div>
  );
};

export const Spin = (props: SpinPropsTypes) => {
  const {
    renderLoading,
    renderError,
    renderEmpty,
    status,
    children,
    className = "",
    loadingClassName,
    reload,
  } = props;
  const render = () => {
    return (
      <div className={cn(loadingClassName)}>
        {status === SPIN_STATUS.LOADING && renderLoading}
        {status === SPIN_STATUS.ERROR &&
          (renderError || <DefaultErrorContent reload={reload} />)}
        {status === SPIN_STATUS.EMPTY && renderEmpty}
      </div>
    );
  };
  const notSuccess = status !== SPIN_STATUS.SUCCESS;
  return (
    <div
      className={cn(className, {
        "overflow-hidden": notSuccess,
      })}
    >
      {notSuccess && render()}
      {(status === SPIN_STATUS.SUCCESS || status === SPIN_STATUS.THINKING) &&
        children}
    </div>
  );
};
